import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	descriptionPlaceholderText: {
		id: 'project-details.description.description-placeholder-text',
		defaultMessage: 'Add a description',
		description: 'Project details description placeholder',
	},
	projectDescriptionLabel: {
		id: 'project-details.description.label-for-project-description-field',
		defaultMessage: 'Description',
		description: 'Description Label',
	},
	editDescriptionLabel: {
		id: 'project-details.description.edit-description-button-label',
		defaultMessage: 'Edit description',
		description: 'Aria-label for edit description button',
	},
});
